import { useMutation } from "@connectrpc/connect-query";
import { ReservationService } from "@viajero/proto/guest/v1";

/**
 * ReservationService.VerifyEmailCode を connect-query mutation でラップするフック。
 *
 * ダイアログで入力した 6 桁コードを照合する (§6.4)。試行は 5 回までで、
 * 超過・期限切れ (5 分) は FailedPrecondition を返し再発行が必要になる。
 */
export function useVerifyEmailCode() {
  return useMutation(ReservationService.method.verifyEmailCode);
}
